import { render, staticRenderFns } from "./VTs.vue?vue&type=template&id=85b59fde&scoped=true"
import script from "./VTs.vue?vue&type=script&lang=js"
export * from "./VTs.vue?vue&type=script&lang=js"
import style0 from "./VTs.vue?vue&type=style&index=0&id=85b59fde&prod&scoped=true&lang=css"
import style1 from "./VTs.vue?vue&type=style&index=1&id=85b59fde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b59fde",
  null
  
)

export default component.exports